import React, { useEffect } from 'react';
import { Link, Redirect } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import AsanConfirmationIcon from "./img/asan-confirmation-icon.svg";
import headerLogo from "./img/header-logo.svg";
import './scss/style.scss';
import { translate } from 'react-i18next';
import { TextField } from '@mui/material';
import { getFormatedDate } from '../../helpers/fotmatDate';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto',
    },
}));

function POSdetailsModal({ item, open, t, closeFunction }) {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={closeFunction}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            classes={classes.modal}
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description">
            <Fade in={open}>
                <div className="feedback-modal" style={{ maxWidth: '764px', maxHeight: '90vh', overflowY: 'auto', marginInline: '2rem' }}>
                    <div className="dashboard-contact-section-form dashboard-account-container-component">
                        <TextField variant="outlined" value={item?.custId} sx={{ width: 300 }} label={t('Customer Code')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={`${item?.customerName} ${item?.customerSurname}`} sx={{ width: 300 }} label={t('Customer Name')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.facilityName} sx={{ width: 300 }} label={t('Object Name')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.facilityAccountingCode} sx={{ width: 300 }} label={t('Object Registration Code')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.tariffName} sx={{ width: 300 }} label={t('Tariff Package')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.cityName} sx={{ width: 300 }} label={t('City/District of the object')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.facilityAddress} sx={{ width: 624 }} label={t('Object address')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.sferadeyName} sx={{ width: 624 }} label={t('Field of activity')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.sferadeyDetail} sx={{ width: 624 }} label={t('detailed')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={item?.branchName} sx={{ width: 300 }} label={t('branch')} InputProps={{ readOnly: true }} />
                        <button className="dashboard-contact-section-button" onClick={closeFunction}>{t('close')}</button>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
export default translate("translation")(POSdetailsModal);